import { useGetApiV1Company } from '@/shared/api/generated';

/**
 * Busca uma única empresa pelo `id` via `/v1/company` (query param `CompanyId`)
 * para exibir o nome como valor inicial do autocomplete de empresa no
 * formulário de Banner — `BannerViewModel` traz `companyId` e às vezes
 * `companyName`, mas não é garantido.
 *
 * Duplicado de `series-management` por regra de FSD (features não se importam
 * lateralmente).
 *
 * @param companyId - Id da empresa; quando `undefined`, a busca fica desabilitada.
 * @returns `{ companyName, isLoading }`.
 */
export function useCompanyById(companyId: number | undefined) {
  const { data, isLoading } = useGetApiV1Company(
    companyId != null ? { CompanyId: companyId } : undefined,
    { query: { enabled: companyId != null } },
  );

  return { companyName: data?.data?.[0]?.name ?? undefined, isLoading } as const;
}
